import { Button, IconButton, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import T from "i18n-react";
import moment from "moment";
import React from 'react';
import { bishopFormats } from '../../constants';
import ProgressBar from "../utility/ProgressBarOneLine";

/**
 * Restituisce tabella con elenco componenti: consumi e scarti
 * @param {array} components 
 * @param {function} declareNewComp 
 * @param {function} declareEditComponent 
 * @param {function} finishDeclaration se diverso da null mostra elenco per inserimento del controllo, altrimenti lista normale
 * @param {boolean} loading
 * @param {object} currentValue
 * @returns 
 */
export const renderComponents = (components, declareNewComp, declareEditComponent, finishDeclaration, loading, currentValue, configuration) => {
    if (components && components.length > 0) {
        return (
            <React.Fragment>
                <div style={finishDeclaration !== null ? { maxHeight: "450px", overflow: "auto" } : null}>
                    {components.map((c, index) => {
                        return (
                            <React.Fragment key={c.id}>
                                <Table size="small">
                                    <tbody>
                                        <TableRow>
                                            <TableCell style={{
                                                maxWidth: '100px',
                                                minWidth: '100px',
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap"
                                            }}>
                                                <div style={{ whiteSpace: 'normal' }}>
                                                    {c.code}
                                                    <div>{c.name}</div>
                                                    {configuration.changeComponent?(
                                                    <Button color="primary" disabled={loading /*|| c.consumptions.length>0*/} variant="contained" size="small" onClick={() => declareNewComp(c.id, false, true)}>
                                                        {T.translate("button.substitute")}
                                                    </Button>
                                                ):null}
                                                </div>
                                            </TableCell>
                                            <TableCell></TableCell>
                                            <TableCell>
                                                <ProgressBar
                                                    total={c?.expectedQuantity} current={c?.consumptions.reduce((acc, obj) => acc + obj.quantity, 0)}
                                                    measure={null} componentsView componentDecimals={configuration?.componentDecimals}
                                                    percentualeOk={configuration?.componentPercentualeOk !== null ? Number((c?.consumptions.reduce((acc, obj) => acc + obj.quantity, 0) / c?.expectedQuantity * 100).toFixed()) > configuration?.componentPercentualeOk : null}
                                                />
                                            </TableCell>
                                            <TableCell align="right" style={{ width: '40%' }}>
                                                <Button color="primary" disabled={loading} variant="contained" size="small" style={{ marginRight: '8px' }} onClick={() => declareNewComp(c.id, false, false)}>
                                                    {T.translate("button.declare")}
                                                </Button>
                                                <Button color="primary" disabled={loading} variant="contained" size="small" onClick={() => declareNewComp(c.id, true, false)}>
                                                    {T.translate("button.discard")}
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    </tbody>
                                </Table>
                                {
                                    c.consumptions && c.consumptions.length > 0 ? (
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell style={{ wordWrap: 'break-word', maxWidth: "100px", minWidth: "100px" }}>{T.translate("component.lot")}</TableCell>
                                                    <TableCell align="right" style={{ wordWrap: 'break-word', maxWidth: "75px", minWidth: "75px" }}>{T.translate("function.qta")}</TableCell>
                                                    <TableCell align="right" style={{ wordWrap: 'break-word', maxWidth: "120px", minWidth: "120px" }}>{T.translate("function.startDate")}</TableCell>
                                                    <TableCell align="right" style={{ wordWrap: 'break-word', maxWidth: "120px", minWidth: "120px" }}>{T.translate("function.endDate")}</TableCell>
                                                    <TableCell style={{ wordWrap: 'break-word', maxWidth: "50px", minWidth: "50px" }}></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {renderConsumptions(c, declareEditComponent, loading, configuration)}
                                            </TableBody>
                                        </Table>
                                    ) : null
                                }
                                {
                                    c.wastes && c.wastes.length > 0 ? (
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell style={{ wordWrap: 'break-word', maxWidth: "100px", minWidth: "100px" }}>{T.translate("component.lot")}</TableCell>
                                                    <TableCell align="right" style={{ wordWrap: 'break-word', maxWidth: "75px", minWidth: "75px" }}>{T.translate("function.qta")}</TableCell>
                                                    <TableCell align="right" style={{ wordWrap: 'break-word', maxWidth: "75px", minWidth: "75px" }}>{T.translate("component.scrapReason")}</TableCell>
                                                    <TableCell align="right" style={{ wordWrap: 'break-word', maxWidth: "100px", minWidth: "100px" }}>{T.translate("component.dateWaste")}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {renderWastes(c, configuration)}
                                            </TableBody>
                                        </Table>
                                    ) : null
                                }
                            </React.Fragment>
                        )
                    })
                    }
                </div >
                {finishDeclaration !== null ? (
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "16px" }}>
                        <Button color="primary" disabled={loading || currentValue} variant="contained" onClick={() => finishDeclaration()}>
                            {T.translate("button.finishDeclaration")}
                        </Button>
                    </div>

                ) : null}
            </React.Fragment >
        )
    } else {
        return (
            <Table>
                <tbody>
                    <TableRow>
                        <TableCell>{T.translate("function.notAvailable").toUpperCase()}!</TableCell>
                    </TableRow>
                </tbody>
            </Table>
        )
    }
}
/**
 * Elenco di table row con li scarti dichiarati del componente
 * @param {object} component 
 * @param {function} onClickEdit 
 * @param {boolean} loading
 * @returns 
 */
export const renderConsumptions = (component, onClickEdit, loading, configuration) => {
    if (component) {
        return (
            component.consumptions.map((c) => {
                return (
                    <TableRow key={c.id + "_" + component.id}>
                        <TableCell style={{ wordWrap: 'break-word', maxWidth: "100px", minWidth: "100px" }}>{c.lot}</TableCell>
                        <TableCell align="right" style={{ wordWrap: 'break-word', maxWidth: "75px", minWidth: "75px" }}>{c.quantity.toFixed(configuration?.componentDecimals)}</TableCell>
                        <TableCell align="right" style={{ wordWrap: 'break-word', maxWidth: "120px", minWidth: "120px" }}>{c.startDate ? moment(c.startDate).format(bishopFormats.LTS) : null}</TableCell>
                        <TableCell align="right" style={{ wordWrap: 'break-word', maxWidth: "120px", minWidth: "120px" }}>{c.endDate ? moment(c.endDate).format(bishopFormats.LTS) : null}</TableCell>
                        <TableCell align="right" style={{ wordWrap: 'break-word', maxWidth: "50px", minWidth: "50px" }}>
                            <IconButton disabled={loading} size="small" color="primary" variant="contained" onClick={() => onClickEdit(component.id, c.id)}>
                                <EditIcon />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                )
            })
        )
    }
}
/**
 * Elenco di tablerow con gli scarti dichiarati del componente
 * @param {object} component 
 * @returns 
 */
export const renderWastes = (component, configuration) => {
    if (component) {
        return (
            component.wastes.map((w) => {
                return (
                    <TableRow key={w.id + "_" + component.id}>
                        <TableCell style={{ wordWrap: 'break-word', maxWidth: "100px", minWidth: "100px" }}>{w.lot}</TableCell>
                        <TableCell align="right" style={{ wordWrap: 'break-word', maxWidth: "75px", minWidth: "75px" }}>{w.quantity.toFixed(configuration?.componentDecimals)}</TableCell>
                        <TableCell align="right" style={{ wordWrap: 'break-word', maxWidth: "75px", minWidth: "75px" }}>{w.reason}</TableCell>
                        <TableCell align="right" style={{ wordWrap: 'break-word', maxWidth: "120px", minWidth: "120px" }}>{w.creationDate ? moment(w.creationDate).format(bishopFormats.LTS) : null}</TableCell>
                    </TableRow>
                )
            })
        )
    }
}
